module.exports = __webpack_public_path__ + "title.50e06add.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/title.jpg
// module id = zD2O
// module chunks = 0